document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.js-weekday-weekend');
    if (!sections) return false;

    const DateObject = new Date();
    const day = DateObject.getDay();
    const dayType = day == 0 || day == 6 ? 'weekend' : 'weekday';
    
    sections.forEach(section => section.classList.add(dayType));
});